import React, { useMemo, useState } from "react";

const categories = [
  "All",
  "Sports",
  "Pop Culture",
  "Lifestyle",
  "Sports Cards",
];

const latestArticles = [
  {
    category: "Sports",
    title: "The stories every fan is talking about this week",
    summary: "A modern digest covering headlines and culture.",
    readTime: "4 min read",
  },
  {
    category: "Pop Culture",
    title: "How media reshapes athlete identity",
    summary: "Athletes now live across platforms and culture.",
    readTime: "5 min read",
  },
  {
    category: "Lifestyle",
    title: "The rise of sports lifestyle coverage",
    summary: "Fans now follow routines, style, and influence.",
    readTime: "6 min read",
  },
  {
    category: "Sports Cards",
    title: "Sports card trends to watch",
    summary: "A look at collector buzz and new releases.",
    readTime: "5 min read",
  },
];

const styles: Record<string, React.CSSProperties> = {
  page: {
    minHeight: "100vh",
    background: "#f7f7f5",
    fontFamily: "Arial, sans-serif",
    color: "#111",
  },
  container: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "20px",
  },
  header: {
    position: "sticky",
    top: 0,
    background: "white",
    padding: "15px 20px",
    borderBottom: "1px solid #ddd",
    zIndex: 10,
  },
  title: {
    fontSize: "28px",
    fontWeight: 700,
  },
  hero: {
    marginTop: "40px",
    marginBottom: "40px",
  },
  heroTitle: {
    fontSize: "40px",
    fontWeight: 700,
    marginBottom: "10px",
  },
  heroText: {
    fontSize: "18px",
    color: "#555",
  },
  sectionTitle: {
    fontSize: "26px",
    fontWeight: 700,
    marginTop: "40px",
    marginBottom: "20px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
  },
  card: {
    background: "white",
    padding: "20px",
    borderRadius: "10px",
    border: "1px solid #eee",
  },
  category: {
    fontSize: "12px",
    fontWeight: 700,
    color: "#777",
  },
  articleTitle: {
    fontSize: "20px",
    fontWeight: 700,
    marginTop: "10px",
  },
  summary: {
    fontSize: "14px",
    marginTop: "10px",
    color: "#555",
  },
  pills: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    marginBottom: "20px",
  },
  pill: {
    padding: "8px 12px",
    borderRadius: "20px",
    border: "1px solid #ccc",
    cursor: "pointer",
    background: "white",
  },
  activePill: {
    padding: "8px 12px",
    borderRadius: "20px",
    border: "1px solid black",
    cursor: "pointer",
    background: "black",
    color: "white",
  },
};

function App() {
  const [activeCategory, setActiveCategory] = useState("All");

  const filtered = useMemo(() => {
    if (activeCategory === "All") return latestArticles;
    return latestArticles.filter((a) => a.category === activeCategory);
  }, [activeCategory]);

  return (
    <div style={styles.page}>
      <header style={styles.header}>
        <div style={styles.title}>Culture and Courtside</div>
      </header>

      <div style={styles.container}>
        <div style={styles.hero}>
          <div style={styles.heroTitle}>
            A modern home for sports, culture, and the sports card hobby.
          </div>
          <div style={styles.heroText}>
            Covering athletes, media, lifestyle, and collecting in one clean
            platform.
          </div>
        </div>

        <div style={styles.sectionTitle}>Browse by Category</div>

        <div style={styles.pills}>
          {categories.map((cat) => (
            <div
              key={cat}
              onClick={() => setActiveCategory(cat)}
              style={activeCategory === cat ? styles.activePill : styles.pill}
            >
              {cat}
            </div>
          ))}
        </div>

        <div style={styles.grid}>
          {filtered.map((article) => (
            <div key={article.title} style={styles.card}>
              <div style={styles.category}>{article.category}</div>
              <div style={styles.articleTitle}>{article.title}</div>
              <div style={styles.summary}>{article.summary}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;
